module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"go_message":"Go to"},"es":{"go_message":"Ir"}}')
  delete Component.options._Ctor
}
